import React from 'react';
import ClubsNavigator from '../navigation/ClubsNavigator';

const ClubsScreen: React.FC = () => {
  return <ClubsNavigator />;
};

export default ClubsScreen;
